import { combineReducers } from "redux"
import models from "./models"

export default combineReducers({
  models,
})
